import React, { useState, useEffect } from 'react';
import axios from 'axios';
import logo from "../../assets/images/logo-123cloud.svg";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import bg from "../../assets/images/bg-login.jpg";

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.body.style.backgroundImage = `url(${bg})`;

        return () => {
            document.body.style.backgroundImage = '';
        };
    }, []);

    const forgetPassword = async (email) => {
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/forgot-password`, { email });

            if (response.status === 200 && response.data.success) {
                setMessage("Đã gửi email khôi phục mật khẩu!");
                setMessageType("success");
                toast.success("Đã gửi email khôi phục mật khẩu!");
            } else {
                setMessage(response.data.message || "Email không tồn tại ");
                setMessageType("error");
                toast.error(response.data.message || "Email không tồn tại ");
            }
        } catch (error) {
            setMessage("Vui lòng chờ ít phút trước khi thử gửi lại email");
            setMessageType("error");
            toast.error("Vui lòng chờ ít phút trước khi thử gửi lại email");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email) {
            setMessage("Email không được để trống!");
            setMessageType("error");
            toast.error("Email không được để trống!");
            return;
        }
        forgetPassword(email);
    };

    return (
        <div className="loginbackground">
            <ToastContainer />
            <div className="row">
                <div className="col-md-12">
                    <div className="row justify-content">
                        <div className="col-md-5 col-lg-5">
                            <section className="ftco-section login">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-md-12">
                                            <div className="d-md-flex box-login">
                                                <div className="col-md-12">
                                                    <div className="login-right">
                                                        <div className="logo-main">
                                                            <img
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    padding: "8px",
                                                                    marginTop: "-5px",
                                                                    width: "30%"
                                                                }}
                                                                className="navbar-brand-full logo-header"
                                                                src={`${process.env.REACT_APP_IMAGE_LOGO}/images/logo.svg`}
                                                                alt="TIDADIGI"
                                                            />
                                                        </div>
                                                        <h1 className="login-title">Quên mật khẩu?</h1>
                                                        <form onSubmit={handleSubmit}>
                                                            <div className="form-group">
                                                                <label htmlFor="email" className="col-form-label">
                                                                    <span style={{ color: 'gray' }}>Nhập email để khôi phục mật khẩu *</span>
                                                                </label>
                                                                <input
                                                                    id="email"
                                                                    type="email"
                                                                    className="form-control"
                                                                    name="email"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    required
                                                                />
                                                                {message && (
                                                                    <div className={`message ${messageType}`}>
                                                                        {message}
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="form-group">
                                                                <button
                                                                    type="submit"
                                                                    className="form-control-btn btn btn-primary submit px-3"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? (
                                                                        <span>
                                                                            <i className="fa fa-spinner fa-spin"></i> Đang gửi...
                                                                        </span>
                                                                    ) : (
                                                                        "Khôi phục mật khẩu"
                                                                    )}
                                                                </button>
                                                            </div>
                                                            <div className="login-bottom">
                                                                <div>
                                                                    <span>
                                                                        Chưa có tài khoản ?{" "}
                                                                        <a
                                                                            href="/register"
                                                                            className="sign-up-now"
                                                                            style={{ textDecoration: 'none' }}
                                                                        >
                                                                            Đăng ký ngay!
                                                                        </a>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
